module.exports = __webpack_public_path__ + "static/media/DefaultGame.72badf75.png";